export function formatDate(date) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const suffix = date.getHours() >= 12 ? 'pm' : 'am';
    const hour = ((date.getHours() + 11) % 12 + 1); // Convert 24hr to 12hr format
    const minute = date.getMinutes().toString().padStart(2, '0');

    return `${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}, ${hour}:${minute}${suffix}`;
}

export function determineDateRelation(date) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const startOfThisWeek = new Date(today);
    startOfThisWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)); // Set to start of this week (Monday)
    const startOfLastWeek = new Date(startOfThisWeek);
    startOfLastWeek.setDate(startOfThisWeek.getDate() - 7); // Set to start of last week
    
    today.setHours(0, 0, 0, 0); 
    startOfThisWeek.setHours(0, 0, 0, 0);
    startOfLastWeek.setHours(0, 0, 0, 0);

    if (date >= today) {
        return "Today";
    } else if (date >= startOfThisWeek) {
        return days[date.getDay()];
    } else if (date >= startOfLastWeek) {
        return "Last week";
    } else {
        return "Older";
    }
}